import React from "react";
import classNames from "classnames";

import styles from "./index.module.scss";

interface Props {
  type?: "Company" | "Event" | "Expanded" | "Feature" | "Small" | "Venue";
  onClick?: () => void;
  smallCard?: boolean;
}

const Card: React.FC<Props> = ({ type, onClick, smallCard, children }) => {
  const classes = classNames(smallCard ? styles.defaultSmall : styles.default, {
    [styles.small]: type === "Small",
    [styles.small]: type === "Small",
    [styles.feature]: type === "Feature",
    [styles.company]: type === "Company",
    [styles.event]: type === "Event",
    [styles.expanded]: type === "Expanded",
    [styles.venue]: type === "Venue",
  });

  return (
    <div className={classes} onClick={onClick}>
      {children}
    </div>
  );
};

export { Card };
